<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="setDialogFilter(true)"
    >
      Filters
    </el-button>
    <el-dialog
      title="Filters"
      :visible="dialog_filter"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialogFilter(false)"
    >
      <el-input type="text" v-model="name" placeholder="Name" clearable />
      <el-input type="text" v-model="email" placeholder="Email" clearable class="mt10"
      />
      <el-checkbox class="ml10 mt10" v-model="unassigned" label="Unassigned users"></el-checkbox>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear()">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter()">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      name: '',
      email: '',
      unassigned: false
    }
  },
  computed: {
    ...mapState('youtubeUsers', ['dialog_filter'])
  },
  methods: {
    ...mapMutations('youtubeUsers', ['setDialogFilter', 'setFilter', 'setPage']),
    ...mapActions('youtubeUsers', ['read']),

    filter() {
      if (this.unassigned === true) {
        this.setFilter({
          unassigned: this.unassigned,
          name: this.name,
          email: this.email
        })
      } else {
        this.setFilter({
          name: this.name,
          email: this.email
        })
      }
      this.setPage(1)
      this.read()
      this.setDialogFilter(false)
    },

    clear() {
      this.setFilter({})
      this.read()
      this.name = ''
      this.email = ''
      this.unassigned = false
      this.setDialogFilter(false)
    }
  }
}
</script>
